export default "__VITE_ASSET__BwNLASGw__"